<kl-form-container
        [mode]="mode"
        [title]="(mode === 'edit' || mode === 'view') ? entity.tax_nr : title"
        [pageId]="tabId ? tabId : modalId"
        [alertMessage]="alertMessage"
        [alertShow]="alertShow"
        [alertType]="alertType"
        (onCloseAlert)="alertShow = false"
        (onCommitSave)="commitSave($event)"
>
    <div class="lem-info-scroll-container">
    <accordion>
        <!-- ========== GENEL BİLGİLER ========== -->
        <accordion-group
                [isOpen]="accordions.general_information"
                (isOpenChange)="accordions.general_information = $event"
        >
            <div accordion-heading class="clearfix">
                {{ "general_information" | translate }}
                <span class="badge badge-secondary float-right pull-right">
          <i
                  class="fa"
                  [ngClass]="
              accordions.general_information ? 'fa-minus' : 'fa-plus'
            "
          ></i>
        </span>
            </div>

            <div class="col-md-12 col-sm-12 row">
                <!-- SOL KOLON -->
                <div class="col-md-6 col-sm-12">
                    <!-- Vergi Numarası -->
                    <div class="form-group row">
                        <label for="lem_tax_nr" class="col-md-3 col-sm-6">
                            <small>{{ "tax_number" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <input
                                    [disabled]="isReadOnly"
                                    type="text"
                                    id="lem_tax_nr"
                                    class="form-control form-control-sm"
                                    name="lem_tax_nr"
                                    [(ngModel)]="entity.tax_nr"
                                    (ngModelChange)="formChange(true)"
                                    maxlength="50"
                            />
                        </div>
                    </div>

                    <!-- Vergi Dairesi -->
                    <div class="form-group row">
                        <label for="lem_tax_office" class="col-md-3 col-sm-6">
                            <small>{{ "tax_office" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <input
                                    [disabled]="isReadOnly"
                                    type="text"
                                    id="lem_tax_office"
                                    class="form-control form-control-sm"
                                    name="lem_tax_office"
                                    [(ngModel)]="entity.tax_office"
                                    (ngModelChange)="formChange(true)"
                                    maxlength="100"
                            />
                        </div>
                    </div>

                    <!-- Şirket Ünvanı -->
                    <div class="form-group row">
                        <label for="lem_company_title" class="col-md-3 col-sm-6">
                            <small>{{ "customer_title" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <textarea
                                    [disabled]="isReadOnly"
                                    id="lem_company_title"
                                    class="form-control form-control-sm"
                                    name="lem_company_title"
                                    [(ngModel)]="entity.company_title"
                                    (ngModelChange)="formChange(true)"
                                    rows="3"
                                    maxlength="250"
                            ></textarea>
                        </div>
                    </div>

                    <!-- Ülke -->
                    <div class="form-group row">
                        <label for="lem_country" class="col-md-3 col-sm-6">
                            <small>{{ "country" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <input
                                    [disabled]="isReadOnly"
                                    type="text"
                                    id="lem_country"
                                    class="form-control form-control-sm"
                                    name="lem_country"
                                    [(ngModel)]="entity.country"
                                    (ngModelChange)="formChange(true)"
                                    maxlength="100"
                            />
                        </div>
                    </div>

                    <!-- İL -->
                    <div class="form-group row">
                        <label for="lem_city" class="col-md-3 col-sm-6">
                            <small>{{ "city" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <input
                                    [disabled]="isReadOnly"
                                    type="text"
                                    id="lem_city"
                                    class="form-control form-control-sm"
                                    name="lem_city"
                                    [(ngModel)]="entity.city"
                                    (ngModelChange)="formChange(true)"
                                    maxlength="100"
                            />
                        </div>
                    </div>

                    <!-- İlçe -->
                    <div class="form-group row">
                        <label for="lem_district" class="col-md-3 col-sm-6">
                            <small>{{ "district" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <input
                                    [disabled]="isReadOnly"
                                    type="text"
                                    id="lem_district"
                                    class="form-control form-control-sm"
                                    name="lem_district"
                                    [(ngModel)]="entity.district"
                                    (ngModelChange)="formChange(true)"
                                    maxlength="100"
                            />
                        </div>
                    </div>

                    <!-- Adres -->
                    <div class="form-group row">
                        <label for="lem_address" class="col-md-3 col-sm-6">
                            <small>{{ "address" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
              <textarea
                      [disabled]="isReadOnly"
                      id="lem_address"
                      class="form-control form-control-sm"
                      name="lem_address"
                      [(ngModel)]="entity.address"
                      (ngModelChange)="formChange(true)"
                      rows="2"
                      maxlength="500"
              ></textarea>
                        </div>
                    </div>

                    <!-- Satınalma -->
                    <div class="form-group row">
                        <label class="col-md-3 col-sm-6">
                            <small>{{ "purchase" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <p-dropdown
                                    [disabled]="isReadOnly"
                                    [options]="[
                    { label: 'Evet' | translate, value: '1' },
                    { label: 'Hayır' | translate, value: '0' }
                  ]"
                                    [(ngModel)]="entity.license_flags[0]"
                                    (onChange)="formChange(true)"
                                    name="license_flag_0"
                                    [style]="{ width: '100%' }"
                                    [placeholder]="'unselected' | translate"
                            ></p-dropdown>
                        </div>
                    </div>

                    <!-- Kantin -->
                    <div class="form-group row">
                        <label class="col-md-3 col-sm-6">
                            <small>{{ "canteen" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <p-dropdown
                                    [disabled]="isReadOnly"
                                    [options]="[
                    { label: 'Evet' | translate, value: '1' },
                    { label: 'Hayır' | translate, value: '0' }
                  ]"
                                    [(ngModel)]="entity.license_flags[1]"
                                    (onChange)="formChange(true)"
                                    name="license_flag_1"
                                    [style]="{ width: '100%' }"
                                    [placeholder]="'unselected' | translate"
                            ></p-dropdown>
                        </div>
                    </div>

                    <!-- Market -->
                    <div class="form-group row">
                        <label class="col-md-3 col-sm-6">
                            <small>{{ "market" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <p-dropdown
                                    [disabled]="isReadOnly"
                                    [options]="[
                    { label: 'Evet' | translate, value: '1' },
                    { label: 'Hayır' | translate, value: '0' }
                  ]"
                                    [(ngModel)]="entity.license_flags[2]"
                                    (onChange)="formChange(true)"
                                    name="license_flag_2"
                                    [style]="{ width: '100%' }"
                                    [placeholder]="'unselected' | translate"
                            ></p-dropdown>
                        </div>
                    </div>

                    <!-- Tpos -->
                    <div class="form-group row">
                        <label class="col-md-3 col-sm-6">
                            <small>{{ "tpos" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <p-dropdown
                                    [disabled]="isReadOnly"
                                    [options]="[
                    { label: 'Evet' | translate, value: '1' },
                    { label: 'HAYIR' | translate, value: '0' }
                  ]"
                                    [(ngModel)]="entity.license_flags[3]"
                                    (onChange)="formChange(true)"
                                    name="license_flag_3"
                                    [style]="{ width: '100%' }"
                                    [placeholder]="'unselected' | translate"
                            ></p-dropdown>
                        </div>
                    </div>

                    <!-- Akaryakıt -->
                    <div class="form-group row">
                        <label class="col-md-3 col-sm-6">
                            <small>{{ "fuel" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <p-dropdown
                                    [disabled]="isReadOnly"
                                    [options]="[
                    { label: 'Evet' | translate, value: '1' },
                    { label: 'Hayır' | translate, value: '0' }
                  ]"
                                    [(ngModel)]="entity.license_flags[4]"
                                    (onChange)="formChange(true)"
                                    name="license_flag_4"
                                    [style]="{ width: '100%' }"
                                    [placeholder]="'unselected' | translate"
                            ></p-dropdown>
                        </div>
                    </div>

                    <!-- Aktif -->
                    <div class="form-group row">
                        <label for="lem_active" class="col-md-3 col-sm-6">
                            <small>{{ "active" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <p-dropdown
                                    [disabled]="isReadOnly"
                                    [options]="[
                  { label: 'Evet' | translate, value: '1' },
                  { label: 'Hayır' | translate, value: '0' }
                ]"
                                    [(ngModel)]="entity.active"
                                    (onChange)="formChange(true)"
                                    name="lem_active"
                                    id="lem_active"
                                    [style]="{ width: '100%' }"
                                    [placeholder]="'unselected' | translate"
                            ></p-dropdown>
                        </div>
                    </div>

                    <!-- Filo -->
                    <div class="form-group row">
                        <label class="col-md-3 col-sm-6">
                            <small>{{ "filo" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <p-dropdown
                                    [disabled]="isReadOnly"
                                    [options]="[
                    { label: 'Evet' | translate, value: '1' },
                    { label: 'Hayır' | translate, value: '0' }
                  ]"
                                    [(ngModel)]="entity.license_flags[7]"
                                    (onChange)="formChange(true)"
                                    name="license_flag_7"
                                    [style]="{ width: '100%' }"
                                    [placeholder]="'unselected' | translate"
                            ></p-dropdown>
                        </div>
                    </div>
                </div>

                <!-- SAĞ KOLON -->
                <div class="col-md-6 col-sm-12">
                    <!-- IDS -->
                    <div class="form-group row">
                        <label for="lem_ids" class="col-md-3 col-sm-6">
                            <small>{{ "ids" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <input
                                    [disabled]="true"
                                    type="text"
                                    id="lem_ids"
                                    class="form-control form-control-sm"
                                    name="lem_ids"
                                    [(ngModel)]="entity.ids"
                                    maxlength="50"
                            />
                        </div>
                    </div>

                    <!-- Master DB Adı -->
                    <div class="form-group row">
                        <label for="lem_master_db_name" class="col-md-3 col-sm-6">
                            <small>{{ "master_db_name" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <input
                                    [disabled]="isReadOnly"
                                    type="text"
                                    id="lem_master_db_name"
                                    class="form-control form-control-sm"
                                    name="lem_master_db_name"
                                    [(ngModel)]="entity.master_db_name"
                                    (ngModelChange)="formChange(true)"
                                    maxlength="100"
                            />
                        </div>
                    </div>

                    <!-- Master DB ID -->
                    <div class="form-group row">
                        <label for="lem_master_db_id" class="col-md-3 col-sm-6">
                            <small>{{ "master_db_id" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <input
                                    [disabled]="isReadOnly"
                                    type="text"
                                    id="lem_master_db_id"
                                    class="form-control form-control-sm"
                                    name="lem_master_db_id"
                                    [(ngModel)]="entity.master_db_id"
                                    (ngModelChange)="formChange(true)"
                                    maxlength="100"
                            />
                        </div>
                    </div>

                    <!-- Master DB Oluşturma Tarihi -->
                    <div class="form-group row">
                        <label for="lem_master_db_create_date" class="col-md-3 col-sm-6">
                            <small>{{ "master_db_create_date" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <p-calendar
                                    [disabled]="isReadOnly"
                                    id="lem_master_db_create_date"
                                    name="lem_master_db_create_date"
                                    [(ngModel)]="masterDbCreateDate"
                                    (ngModelChange)="formChange(true)"
                                    dateFormat="dd.mm.yy"
                                    [style]="{ width: '100%' }"
                                    [placeholder]="'unselected' | translate"
                            ></p-calendar>
                        </div>
                    </div>

                    <!-- SQL Server Adı -->
                    <div class="form-group row">
                        <label for="lem_sql_server_name" class="col-md-3 col-sm-6">
                            <small>{{ "sql_server_name" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <input
                                    [disabled]="isReadOnly"
                                    type="text"
                                    id="lem_sql_server_name"
                                    class="form-control form-control-sm"
                                    name="lem_sql_server_name"
                                    [(ngModel)]="entity.sql_server_name"
                                    (ngModelChange)="formChange(true)"
                                    maxlength="100"
                            />
                        </div>
                    </div>

                    <!-- SQL Server Parmak İzi -->
                    <div class="form-group row">
                        <label for="lem_sql_server_thumbprint" class="col-md-3 col-sm-6" style="white-space: nowrap;">
                            <small>{{ "sql_server_thumbprint" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <input
                                    [disabled]="isReadOnly"
                                    type="text"
                                    id="lem_sql_server_thumbprint"
                                    class="form-control form-control-sm"
                                    name="lem_sql_server_thumbprint"
                                    [(ngModel)]="entity.sql_server_thumbprint"
                                    (ngModelChange)="formChange(true)"
                                    maxlength="200"
                            />
                        </div>
                    </div>

                    <!-- LEM Bitiş Tarihi -->
                    <div class="form-group row">
                        <label for="lem_lem_end_date" class="col-md-3 col-sm-6">
                            <small>{{ "lem_end_date" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <p-calendar
                                    [disabled]="isReadOnly"
                                    id="lem_lem_end_date"
                                    name="lem_lem_end_date"
                                    [(ngModel)]="lemEndDate"
                                    (ngModelChange)="formChange(true)"
                                    dateFormat="dd.mm.yy"
                                    [style]="{ width: '100%' }"
                                    [placeholder]="'unselected' | translate"
                            ></p-calendar>
                        </div>
                    </div>

                    <!-- Logo Ürün Anahtarı -->
                    <div class="form-group row">
                        <label for="lem_logo_product_key" class="col-md-3 col-sm-6">
                            <small>{{ "logo_product_key" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <input
                                    [disabled]="isReadOnly"
                                    type="text"
                                    id="lem_logo_product_key"
                                    class="form-control form-control-sm"
                                    name="lem_logo_product_key"
                                    [(ngModel)]="entity.logo_product_key"
                                    (ngModelChange)="formChange(true)"
                                    maxlength="100"
                            />
                        </div>
                    </div>

                    <!-- Ürün ID -->
                    <div class="form-group row">
                        <label for="lem_product_id" class="col-md-3 col-sm-6">
                            <small>{{ "product_id" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <input
                                    [disabled]="isReadOnly"
                                    type="text"
                                    id="lem_product_id"
                                    class="form-control form-control-sm"
                                    name="lem_product_id"
                                    [(ngModel)]="entity.product_id"
                                    (ngModelChange)="formChange(true)"
                                    maxlength="50"
                            />
                        </div>
                    </div>

                    <!-- Ürün Versiyonu -->
                    <div class="form-group row">
                        <label for="lem_product_version" class="col-md-3 col-sm-6">
                            <small>{{ "product_version" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <input
                                    [disabled]="isReadOnly"
                                    type="text"
                                    id="lem_product_version"
                                    class="form-control form-control-sm"
                                    name="lem_product_version"
                                    [(ngModel)]="entity.product_version"
                                    (ngModelChange)="formChange(true)"
                                    maxlength="50"
                            />
                        </div>
                    </div>

                    <!-- Şube Sayısı -->
                    <div class="form-group row">
                        <label for="branch_count" class="col-md-3 col-sm-6">
                            <small>{{ "branch_count" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <input
                                    [disabled]="isReadOnly"
                                    type="text"
                                    id="branch_count"
                                    class="form-control form-control-sm"
                                    name="branch_count"
                                    [(ngModel)]="entity.branch_count"
                                    (ngModelChange)="formChange(true)"
                                    maxlength="7"
                                    (input)="onlyNumber($event)"
                            />
                        </div>
                    </div>

                    <!-- Dosya Versiyonu -->
                    <div class="form-group row">
                        <label for="lem_file_version" class="col-md-3 col-sm-6">
                            <small>{{ "file_version" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <input
                                    [disabled]="isReadOnly"
                                    type="text"
                                    id="lem_file_version"
                                    class="form-control form-control-sm"
                                    name="lem_file_version"
                                    [(ngModel)]="entity.file_version"
                                    (ngModelChange)="formChange(true)"
                                    maxlength="50"
                            />
                        </div>
                    </div>

                    <!-- Bayi -->
                    <div class="form-group row">
                        <label class="col-md-3 col-sm-6">
                            <small>{{ "bayi" | translate }}</small>
                        </label>
                        <div class="col-md-9 col-sm-6">
                            <p-dropdown
                                    [disabled]="isReadOnly"
                                    [options]="[
                    { label: 'Evet' | translate, value: '1' },
                    { label: 'Hayır' | translate, value: '0' }
                  ]"
                                    [(ngModel)]="entity.license_flags[6]"
                                    (onChange)="formChange(true)"
                                    name="license_flag_6"
                                    [style]="{ width: '100%' }"
                                    [placeholder]="'unselected' | translate"
                            ></p-dropdown>
                        </div>
                    </div>

                    <!-- Müşteri -->
                    <div class="form-group row">
                        <label for="current_account" class="col-md-3 col-sm-6">
                            <small>{{ "customer_code" | translate }}</small>
                        </label>
                        <div class="input-group col-md-9 col-sm-9">
                            <input
                                    class="form-control form-control-sm"
                                    [value]="entity.customer?.code || ''"
                                    [disabled]="true"
                                    id="current_account"
                                    name="current_account"
                            />
                            <a class="inputClear" (click)="clearCurrentAccount()">
                                <i class="fal fa-close"></i>
                            </a>
                            <div
                                    class="input-group-append"
                                    (click)="!isReadOnly ? setModal() : ''"
                            >
                <span class="input-group-text transparent" id="basic-addon342">
                  <i class="fal fa-ellipsis-h" aria-hidden="true"></i>
                </span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="current_account" class="col-md-3 col-sm-6">
                            <small>{{ "customer_description" | translate }}</small>
                        </label>
                        <div class="input-group col-md-9 col-sm-9">
                            <input
                                    class="form-control form-control-sm"
                                    [value]="entity.customer?.description || ''"
                                    [disabled]="true"
                                    id="current_account_"
                                    name="current_account_"
                            />
                            <a class="inputClear" (click)="clearCurrentAccount()">
                                <i class="fal fa-close"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </accordion-group>

        <accordion-group
                class="mt-1"
                [isOpen]="accordions.logo_get_info"
                (isOpenChange)="accordions.logo_get_info = $event"
        >
            <div accordion-heading class="clearfix">
                {{ "logo_get_info" | translate }}
                <span class="badge badge-secondary float-right pull-right">
      <i class="fa" [ngClass]="accordions.logo_get_info ? 'fa-minus' : 'fa-plus'"></i>
    </span>
            </div>

            <!-- ==================== LOGO LİSANS CHECKBOX ALANI ==================== -->
            <div class="col-md-12 col-sm-12 mt-3">
                <div class="form-group">
                    <label>
                        <small>{{ "license_flags" | translate }}</small>
                    </label>
                    <div class="row" *ngIf="logoLicenseFlags && logoLicenseFlags.length > 0">
                        <div class="col-md-3 col-sm-6" *ngFor="let flag of logoLicenseFlags; let i = index">
                            <div class="form-check">
                                <p-checkbox
                                        [disabled]="true"
                                        [binary]="true"
                                        [(ngModel)]="flag.checked"
                                        [ngModelOptions]="{ standalone: true }"
                                        [label]="flag.label + (flag.displayValue ? ' (' + flag.displayValue + ')' : '')"
                                        name="logo_license_flag_{{ i }}"
                                        id="logo_license_flag_{{ i }}"
                                ></p-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- ==================== /CHECKBOX ALANI ==================== -->
        </accordion-group>
    </accordion>
    </div>
</kl-form-container>